// <pos-xiaocang-alerts/> — 小倉每日預測與警告
// see architecture.md#L410 (小倉)

class PosXiaocangAlerts extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.predictions = [];
  }

  async connectedCallback() {
    // TODO(W5): fetch from /.netlify/functions/ai/xiaocang-predictions
    this.render();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host { display: block; padding: var(--s-5); max-width: 900px; margin: 0 auto; }
        h2 { font-family: var(--font-display); color: var(--brand-primary); }
        .card {
          padding: var(--s-5);
          background: var(--bg-elevated);
          border-radius: var(--r-md);
          margin-bottom: var(--s-4);
          border-left: 4px solid var(--border);
        }
        .card.restock_now { border-left-color: var(--danger); }
        .card.monitor { border-left-color: var(--warning); }
        .card.sufficient { border-left-color: var(--success); }
        .item-name { font-size: 18px; font-weight: 600; margin-bottom: var(--s-2); }
        .recommend {
          display: inline-block;
          padding: 2px 10px;
          border-radius: var(--r-full);
          font-size: 12px;
          font-weight: 600;
          margin-left: var(--s-3);
        }
        .recommend.restock_now { background: var(--danger); color: white; }
        .recommend.monitor { background: var(--warning); color: var(--fg-on-brand); }
        .recommend.sufficient { background: var(--success); color: var(--fg-on-brand); }
        .analysis { color: var(--fg-muted); line-height: 1.7; margin-top: var(--s-3); }
        .meta { display: flex; gap: var(--s-5); font-size: 13px; color: var(--fg-muted); margin-top: var(--s-3); }
        .empty { text-align: center; color: var(--fg-muted); padding: var(--s-10); }
      </style>

      <h2>🌾 小掌櫃今日庫存提醒</h2>

      ${this.predictions.length === 0 ? `
        <div class="empty">
          今天還沒有提醒資料。<br/>
          <small>（每日 03:00 由小掌櫃掃描效期壓力 + 推薦消化菜品）</small>
        </div>
      ` : this.predictions.map((p) => `
        <div class="card ${p.recommendation}">
          <div class="item-name">
            ${p.item_name}
            <span class="recommend ${p.recommendation}">
              ${p.recommendation === 'restock_now' ? '🚨 建議進貨' : p.recommendation === 'monitor' ? '👀 監控中' : '✓ 充足'}
            </span>
          </div>
          <div class="analysis">${p.ai_analysis}</div>
          <div class="meta">
            <div>當前庫存：<strong>${p.current_stock} ${p.unit}</strong></div>
            <div>預估 7 日用量：<strong>${p.predicted_usage_7d || '—'}</strong></div>
            <div>預估用完日：<strong>${p.predicted_depletion_date || '—'}</strong></div>
            ${p.recommended_qty ? `<div>建議進貨：<strong>${p.recommended_qty} ${p.unit}</strong></div>` : ''}
          </div>
          <div style="margin-top:var(--s-3); font-size:11px; color:var(--fg-dim);">
            信心度 ${(p.confidence_score * 100).toFixed(0)}% · ${p.model}
          </div>
        </div>
      `).join('')}
    `;
  }
}

customElements.define('pos-xiaocang-alerts', PosXiaocangAlerts);
